import { Stepper } from 'ui';

const SetupPeerPageStepper = ({ activeStep }: { activeStep: number }) => {
  return (
    <Stepper active={activeStep}>
      <Stepper.Step />
      <Stepper.Step />
      <Stepper.Step />
    </Stepper>
  );
};

export { SetupPeerPageStepper };
